import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import dayjs from "dayjs";

import PrintWrapper from "../../../../components/common/PrintWrapper";
import PayslipPreview from "./PayslipPreview";
import { getPublicPayslip } from "../../../../apiservice/hrpayroll";

const PayslipPrintPuppeteer = () => {

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [data,setData] = useState(null);

  useEffect(()=>{

    if(!token) return;

    const load = async () => {

      try{
        const res = await getPublicPayslip(token);
        setData(res);

      }catch(err){
        console.error("Payslip fetch error:",err);
      }

    };

    load();

  },[token]);


  useEffect(() => {
  if (!data) return;

    const generateAndDownload = async () => {
      try {
        const element = document.getElementById("payslip-preview");
        if (!element) return;

        // wait a bit to ensure full render
        await new Promise((resolve) => setTimeout(resolve, 500));

        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
        });

        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "a4",
        });

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

        pdf.save(`Payslip_${data.employee.employee_name}.pdf`);

        // ✅ OPTIONAL: auto close tab after download
        setTimeout(() => {
          window.close();
        }, 1500);

      } catch (err) {
        console.error("Auto download failed:", err);
      }
    };

    generateAndDownload();

  }, [data]);

  if(!data){
    return <div className="payslip-root">Loading...</div>;
  }

  return (

    <PrintWrapper
      title={`Payslip_${data.employee.employee_name}`}
      layout="landscape"
      showControls={false}
    >

      <PayslipPreview
        employee={{
          ...data.employee,
          payslip_month: dayjs(`${data.year}-${data.month}-01`).format("MMMM YYYY")
        }}
        currency={data.currency}
        logoUrl={data.logoUrl}
        selectedYear={data.year}
        attendanceSummary={data.attendanceSummary}
        payDetails={data.payDetails}
      />

    </PrintWrapper>

  );

};

export default PayslipPrintPuppeteer;